/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react"
import { Eyebrow, Headline, GridLines } from "@shared"
import { PageSection } from "@components/sections/PageSection"
import { CONSTANTS } from "@data"
import { css } from "@jsUtils"

import Styles from "./technologyInteractive.module.scss"

const { THEMES, COLORS } = CONSTANTS

/**
 * TechnologyInteractive section
 * @param {object} props - React props
 */
const TechnologyInteractive = props => {
  const [rotation, setRotation] = React.useState(180)
  const [isInteracting, setIsInteracting] = React.useState(false)
  const [lastPosition, setLastPosition] = React.useState(0)

  const onMouseDown = e => {
    setIsInteracting(true)
    setLastPosition(e.pageY)
  }

  const onMouseMove = e => {
    if (isInteracting) {
      const currentPosition = e.pageY
      const positionDelta = lastPosition - currentPosition
    }
  }

  const onMouseUp = e => {
    setIsInteracting(false)
    // console.log(e)
  }

  return (
    <PageSection className={Styles.section} theme={THEMES.BLACK}>
      <GridLines theme={THEMES.DARK} />
      <div className={Styles.content}>
        <div className={Styles.firstSection}>
          <Eyebrow className={Styles.firstEyebrow} color={COLORS.MIDSOMMAR}>
            Universal Transducer
          </Eyebrow>
          <Headline size={2} className={Styles.firstHeadline}>
            See everything more clearly
          </Headline>
          <p className={Styles.firstDescription}>
            Our patented multi-mode pMUT technology provides maximum versatility. Only Chroma™ can
            image with extremely high bandwidth across a wide range of applications on a single
            chip.
          </p>
          <Headline size={4} className={Styles.firstSubhead}>
            Now you can use the same transducer to image the entire body including the heart, the
            abdomen or musculoskeletal features.
          </Headline>
        </div>
        <div className={Styles.secondSection}>
          <Eyebrow className={Styles.secondEyebrow} color={COLORS.MIDSOMMAR}>
            Ultrasound Computer Tomography
          </Eyebrow>
          <Headline size={2} className={Styles.secondHeadline}>
            Diagnose in three dimensions
          </Headline>
          <div className={Styles.secondSplit}>
            <p className={Styles.secondDescription}>
              With thousands of individually precisely controlled elements, each with unique
              transmit and receive controls and advanced beam forming capabilities, Chroma™ allows
              you to obtain and dice volumetric data. That way you get the full picture any way you
              slice it.
            </p>
            <div className={Styles.interactiveSection}>
              <div
                className={Styles.interactionArm}
                style={{ transform: `rotateZ(${rotation * 0.5}deg)` }}
              >
                <button
                  onMouseUp={e => onMouseUp(e)}
                  onMouseDown={e => onMouseDown(e)}
                  onMouseMove={e => onMouseMove(e)}
                  type="button"
                  className={Styles.interactionControl}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export default TechnologyInteractive
